/**
 * OKS-1037 — mirror of `Shipments.plausible_phone?` (app/services/shipments.rb):
 * allowed characters only, and 6..20 DIGITS.
 *
 * ⚠️ PRESENTATIONAL. It decides whether the confirm dialog shows the phone as a
 * read-only line or as a required input. The server re-validates every submit
 * and its field error is the authority; if the two ever disagree the dialog
 * just shows the input one render late.
 */
const PHONE_FORMAT = /^\+?[\d\s.()-]+$/
const PHONE_DIGIT_MIN = 6
const PHONE_DIGIT_MAX = 20

export function plausiblePhone(value: string | null | undefined): boolean {
  if (!value || value.trim() === "") return false
  if (!PHONE_FORMAT.test(value)) return false

  const digits = value.replace(/\D/g, "").length
  return digits >= PHONE_DIGIT_MIN && digits <= PHONE_DIGIT_MAX
}
